/**
 * ImsError
 * a class to help determine the severity of errors
 * this was originally built for catching the login,
 * and profile lookup errors, to ensure we show the
 * right messages to the right problems like:
 * AdBlockers
 * Expired window._bearer tokens
 * etc
 */
export default class ImsError {
  error: Error;
  _error: any;
  errors: any = {
    general: { message: 'Unidentified error', throw: true, fatal: false },
    'hidden iframes': {
      message: 'Hidden frame known error',
      type: 'general',
      throw: false,
      fatal: false
    },
    "Cannot read property 'json' of undefined": {
      message: `Unable to call the API, do you have an Adblocker enabled?`,
      type: 'session',
      throw: true,
      fatal: true
    },
    unauthorized: {
      message: `You are unauthorized to access this resource`,
      type: 'session',
      throw: true,
      fatal: false
    },
    'User does not have an existing session': {
      message:
        'Session is invalid. Disable any ad blockers and ensure you are online',
      type: 'session',
      throw: true,
      fatal: true
    }
  };
  constructor(error: Error) {
    this.error = error;
    // Loop over error keys - find the match
    let matched = Object.keys(this.errors).find(lookupStr => {
      let regex = new RegExp(lookupStr, 'gi');
      return this.error.message.search(regex) > -1;
    });
    // if a match is found
    if (matched) {
      // set error to matched error data
      this._error = this.errors[matched];
    } else {
      // set to generic error
      this._error = this.errors.general;
    }
    // If it's fatal - console error it.
    if (this._error.fatal) {
      console.error(
        'A fatal error has occured',
        this._error.message,
        this.error.message
      );
    }
  }
  // Is this a fatal error
  public isFatal(): boolean {
    return this._error.fatal ? true : false;
  }
  // Get the errors actual description
  public getDescription(): string {
    return this._error.message;
  }
  // Throw an error if throwable
  public throw(): void {
    if (this._error.throw) {
      throw this.error;
    }
  }
}
